import mutations from "./mutations";
import queries from "./queries";
import subscriptions from "./subscriptions";

const operations = { queries, subscriptions, mutations };

export default operations;
